/*
  This is used to maintain a list of countries to understand what is affected by privacy
  and what isn't affected by privacy. In the future, I hope that we will have a way to
  provide this list outside of hard coding it from One Tag/user-consent-management.
*/
const EU_PRIVACY_COUNTRIES = [
  'AT',
  'BE',
  'CZ',
  'DE',
  'DK',
  'EI',
  'ES',
  'EU',
  'FI',
  'FR',
  'GB',
  'HU',
  'ICC',
  'IE',
  'IT',
  'NO',
  'NL',
  'PL',
  'SE',
  'XA',
  'XB',
];

export default EU_PRIVACY_COUNTRIES;
